import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import { fetchCollection } from '../lib/marketCatalog';
import MarketShell from '../components/market/MarketShell';
import { CardRow } from './MarketHome';

// /market/collection/:slug — one curated collection in full (its "see all").
// The order is the collection's own: staff pins, then the stored ranking.

const T = {
  ar: { market: 'السوق', more: 'عرض المزيد', none: 'لا توجد منتجات في هذه المجموعة الآن.', missing: 'هذه المجموعة غير متاحة.' },
  en: { market: 'Market', more: 'Show more', none: 'No products in this collection right now.', missing: 'This collection is not available.' },
};
T.zh = T.en;
const PAGE = 24;

export default function MarketCollection({ lang = 'ar', user, exchangeRates }) {
  const nav = useNavigate();
  const { slug = '' } = useParams();
  const c = T[lang] || T.ar;
  usePageTitle('market', lang);
  const [col, setCol] = useState(undefined);
  const [more, setMore] = useState(true);
  useEffect(() => {
    let alive = true;
    setCol(undefined);
    fetchCollection(slug, PAGE, 0).then(({ collection }) => { if (alive) { setCol(collection); setMore((collection?.rows.length ?? 0) === PAGE); } });
    return () => { alive = false; };
  }, [slug]);
  const loadMore = async () => {
    const { collection } = await fetchCollection(slug, PAGE, col.rows.length);
    const next = collection?.rows ?? [];
    setCol({ ...col, rows: [...col.rows, ...next] });
    setMore(next.length === PAGE);
  };
  const t = (k) => (col ? (lang === 'ar' ? col[`${k}_ar`] : col[`${k}_en`]) : '');
  return (
    <MarketShell lang={lang} user={user}>
      <div className="mk-wrap" style={{ paddingBottom: 48 }}>
        <div className="mk-crumbs" aria-label="breadcrumb">
          <button type="button" onClick={() => nav('/market')}>{c.market}</button>
          {col && <><span aria-hidden="true">›</span><span aria-current="page">{t('title')}</span></>}
        </div>
        {col === undefined ? <div className="mk-grid cols-4" style={{ marginTop: 16 }}>{Array.from({ length: 8 }, (_, i) => <div key={i} className="mk-skel" style={{ aspectRatio: '3 / 4' }} />)}</div>
          : col === null ? <p className="mk-empty" data-collection-missing="1">{c.missing}</p>
          : (
            <>
              <div className="mk-listing-head"><h1 data-collection-title={col.slug}>{t('title')}</h1></div>
              {t('subtitle') && <p className="mk-note" style={{ marginTop: 0 }}>{t('subtitle')}</p>}
              {col.rows.length === 0 ? <p className="mk-empty">{c.none}</p> : (
                <div data-collection-rows={col.rows.length}>
                  <CardRow rows={col.rows} lang={lang} user={user} exchangeRates={exchangeRates} max={col.rows.length} cols={4} />
                  {more && <div style={{ textAlign: 'center', marginTop: 18 }}><button type="button" className="mk-btn ghost" onClick={loadMore}>{c.more}</button></div>}
                </div>
              )}
            </>
          )}
      </div>
    </MarketShell>
  );
}
